import React from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, Circle } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const COLOR = { origin: "#0D5C58", person: "#8BA4B5", business: "#64748B", organization: "#127a74", place: "#4b6a82", group: "#6d7f91", event: "#5a738a" };

export default function NetworkMap({ origin, nodes, onSelect, selectedId }) {
  const center = origin?.lat != null ? [origin.lat, origin.lng] : [51.5074, -0.1278];
  const geoNodes = nodes.filter((n) => n.lat != null && n.lng != null);

  return (
    <div className="w-full h-full" data-testid="network-map">
      <MapContainer center={center} zoom={15} style={{ width: "100%", height: "100%" }} scrollWheelZoom>
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; OpenStreetMap &copy; CARTO'
        />
        {origin?.lat != null && origin.boundary_kind === "radius" && origin.radius_m && (
          <Circle center={[origin.lat, origin.lng]} radius={origin.radius_m}
            pathOptions={{ color: "#0D5C58", fillColor: "#0D5C58", fillOpacity: 0.07, weight: 1 }} />
        )}
        {geoNodes.map((n) => (
          <CircleMarker key={n.id} center={[n.lat, n.lng]}
            radius={n.kind === "origin" ? 9 : 6}
            pathOptions={{
              color: n.id === selectedId ? "#F8FAFC" : COLOR[n.kind === "origin" ? "origin" : n.type] || "#64748B",
              fillColor: COLOR[n.kind === "origin" ? "origin" : n.type] || "#64748B",
              fillOpacity: 0.85, weight: n.id === selectedId ? 2 : 1,
            }}
            eventHandlers={{ click: () => onSelect && onSelect(n) }}>
            <Popup>
              <div style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
                <strong>{n.label}</strong><br />
                {n.type}{n.distance_m != null ? ` · ${n.distance_m}m` : ""}
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
